import { useEffect, useState, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import {InsertOrUpdateIpSettingsModal, DeleteIpSettingsModal} from "../components/modals/IpSettingsModal";
import editIcon from "../../../assets/images/grid_edit.gif";
import { toast } from "react-toastify";
import { getIPSettings } from "../services/ipSettings_service";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";
import deleteIcon from "../../../assets/images/SBA/Delete.png";

const IP_TYPES = {
  BLACKLIST: "black",
  WHITELIST: "white"
};

const IpSettingsPage = () => {
    useDocumentTitle("IP Settings")
  const [activeTab, setActiveTab] = useState(IP_TYPES.BLACKLIST);
  const [rowData, setRowData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);

  const fetchData = async () => {

    try {

      let gridData;

      const response = await getIPSettings();
      if (activeTab === IP_TYPES.BLACKLIST){
        gridData = response.data.filter((item) => item.isBlocked);
        setRowData(gridData)
      }
      else{
        gridData = response.data.filter((item) => !item.isBlocked);
        setRowData(gridData)
      }


    }
    catch {
      toast.error("Unable to load IP settings");
      setRowData([]);
    }

  };

  useEffect(() => {
    fetchData();
  }, [activeTab]);

  const handleAdd = () => {

    setMode("add");

    setSelectedRow({
      ipAddress: "",
      comments: "",
      isActive: true,
      isBlocked: activeTab === IP_TYPES.BLACKLIST
    });

    setShowModal(true);
  };

  const handleEdit = (row) => {

    setMode("edit");
    setSelectedRow(row);
    setShowModal(true);

  };

  const handleDelete = (row) => {
  setDeleteRow(row);
  setShowDeleteModal(true);
};



const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours ? hours : 12;

        return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
    };

  const ActionRenderer = (params) => {

    const row = params.data;

    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <img
          src={editIcon}
          alt="Edit"
          style={{ cursor: "pointer", width: "16px" }}
          onClick={() => handleEdit(row)}
        />
        <img
        src={deleteIcon}
        alt="Delete"
        style={{ cursor: "pointer", width: "16px" }}
        onClick={() => handleDelete(row)}
      />
      </div>
    );

  };

  const columnDefs = useMemo(() => [

    {
      headerName: "IP Address",
      field: "ipAddress",
      flex: 2
    },

    {
      headerName: "Active",
      field: "active",
      maxWidth: 120,
      cellRenderer: p => p.value ? "Yes" : "No"
    },

    {
      headerName: "Blocked",
      field: "isBlocked",
      maxWidth: 120,
      cellRenderer: p => p.value ? "Yes" : "No"
    },

    {
      headerName: "Description",
      field: "comments",
      flex: 2
    },

    {
      headerName: "Created Date",
      field: "createdDate",
      flex: 1,
      valueFormatter: (params) => formatDateTime(params.value) 
    },

    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ActionRenderer,
      sortable: false,
      filter: false,
      flex:1
    }

  ], []);

  const getClass = (tab) =>
    activeTab === tab ? "active" : "";

  return (
    <>

      {/* TAB HEADER */}

      <ul className="nav nav-tabs">

        <li role="presentation" className={getClass(IP_TYPES.BLACKLIST)}>
          <a onClick={() => setActiveTab(IP_TYPES.BLACKLIST)}>
            Black List
          </a>
        </li>

        <li role="presentation" className={getClass(IP_TYPES.WHITELIST)}>
          <a onClick={() => setActiveTab(IP_TYPES.WHITELIST)}>
            White List
          </a>
        </li>

      </ul>

      {/* ACTION BAR */}

      <div style={{ marginTop: "15px", marginBottom: "10px", textAlign: "right" }}>

        <button
          className="btn btn-primary"
          onClick={handleAdd}
        >
          Add
        </button>

      </div>

      {/* GRID */}

      <div
        className="ag-theme-alpine"
        style={{ height: 500, width: "100%" }}
      >
        <AgGridReact
          theme={"legacy"}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          animateRows={true}
          defaultColDef={{
            tooltipValueGetter: (p) => p.value
          }}
        />
      </div>

      {showModal && (

        <InsertOrUpdateIpSettingsModal
          show={showModal}
          mode={mode}
          type={activeTab}
          initialData={selectedRow}
          onClose={() => setShowModal(false)}
          dataReload={fetchData}
        />

      )}

      {showDeleteModal && (

  <DeleteIpSettingsModal
    show={showDeleteModal}
    type={activeTab}
    rowData={deleteRow}
    onClose={() => setShowDeleteModal(false)}
    dataReload={fetchData}
  />

)}

    </>
  );
};

export default IpSettingsPage;